export default {
  init() {
    // JavaScript to be fired on all pages
    // Shrinking header
    $(window).scroll(function() {
        if ($(document).scrollTop() > 5) {
          $('.navbar-marketing').addClass('navbar-scrolled');
        } else {
          $('.navbar-marketing').removeClass('navbar-scrolled');
        }
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

        $('[data-toggle="tooltip"]').tooltip()


       $('.page-scroll').bind('click', function(event) {
            var $anchor = $(this);
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top -95
            }, 300, 'easeInOutExpo');
            event.preventDefault();
        });


        $(".video-container").fitVids();

        

        (function () {
            var e = document.querySelectorAll(".navbar-nav .dropdown, .navbar-nav .dropright"),
                n = ["mouseenter"],
                a = ["mouseleave", "click"];
            [].forEach.call(e, function (t) {
                var o = t.querySelector(".dropdown-menu");
                n.forEach(function (e) {
                    t.addEventListener(e, function () {
                        !(function (e) {
                            window.innerWidth < 992 ||
                                (e.classList.add("showing"),
                                setTimeout(function () {
                                    e.classList.remove("showing"), e.classList.add("show");
                                }, 1));
                        })(o);
                    });
                }),
                    a.forEach(function (e) {
                        t.addEventListener(e, function (e) {
                            !(function (e, t) {
                                setTimeout(function () {
                                    window.innerWidth < 992 ||
                                        (t.classList.contains("show") &&
                                            (("click" === e.type && e.target.closest(".dropdown-menu form")) ||
                                                (t.classList.add("showing"),
                                                t.classList.remove("show"),
                                                setTimeout(function () {
                                                    t.classList.remove("showing");
                                                }, 200))));
                                }, 2);
                            })(e, o);
                        });
                    });
            });
        })()


        AOS.init();


        // Select2 formatting
        function format (item) {
          return $(item.element).html();
        }
        // Select2 Targeting
        $('.orderby').select2({
            formatResult: format,
            formatSelection: format,
            escapeMarkup: function (text) { return text; },
            minimumResultsForSearch: Infinity
        });

        $('.woocommerce-perpage select').select2({
            formatResult: format,
            formatSelection: format,
            escapeMarkup: function (text) { return text; },
            minimumResultsForSearch: Infinity
        });

        $('.single-product select').select2({
            formatResult: format,
            formatSelection: format,
            escapeMarkup: function (text) { return text; },
            minimumResultsForSearch: Infinity
        });

        
        // cart quantity buttons
        $(document).on( 'click', '.qodef-quantity-minus, .qodef-quantity-plus', function(e) {
            e.stopPropagation();

            var button = $(this),
                inputField = button.siblings('.qodef-quantity-input'),
                //inputField = $( '.qodef-quantity-input' ), 
                step = parseFloat(inputField.attr('step')),
                max = parseFloat(inputField.attr('max')),
                minus = false,
                inputValue = parseFloat(inputField.val()),
                newInputValue;

            if (button.hasClass('qodef-quantity-minus')) {
                minus = true;
            }

            if (minus) {
                newInputValue = inputValue - step;
                if (newInputValue >= 1) {
                    inputField.val(newInputValue);
                } else {
                    inputField.val(1);
                }
            } else {
                newInputValue = inputValue + step;
                if ( max === undefined ) {
                    inputField.val(newInputValue);
                } else {
                    if ( newInputValue >= max ) {
                        inputField.val(max);
                    } else {
                        inputField.val(newInputValue);
                    }
                }
            }
            inputField.trigger( 'change' );
        });



        // sidebars linked from header
         jQuery(document).ready(function($) {
            var $L = 1200,
            
            $cart_trigger = $('#cd-cart-trigger'),
            $cart_close = $('#cd-cart-close'),
            $lateral_cart = $('#cd-cart'),
            $shadow_layer = $('#cd-shadow-layer');

            $cart_trigger.on('click', function(event) {
                event.preventDefault();
                toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
            });

            $cart_close.on('click', function(event) {
               //event.preventDefault();
               if ($lateral_cart.hasClass('speed-in')) {
                    $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                        $('body').removeClass('overflow-hidden');
                    });
                    $shadow_layer.removeClass('is-visible');
                }
            });
            $shadow_layer.on('click', function() {
                $shadow_layer.removeClass('is-visible');
                if ($lateral_cart.hasClass('speed-in')) {
                    $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                        $('body').removeClass('overflow-hidden');
                    });
                } else {
                    $lateral_cart.removeClass('speed-in');
                }
            });


            // opens the sidebar after adding to cart
            // jQuery( document.body ).on( 'added_to_cart', function(){
            //     console.log('EVENT: added_to_cart');
            //     toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
            // });


        });
        function toggle_panel_visibility($lateral_panel, $background_layer, $body) {
            if ($lateral_panel.hasClass('speed-in')) {
                $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    $body.removeClass('overflow-hidden');
                });
                $background_layer.removeClass('is-visible');
            } else {
                $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    $body.addClass('overflow-hidden');
                });
                $background_layer.addClass('is-visible');
            }
        }
        

        // By default submit is disabled unless user adds search term (prevents empty searches)
        $('.btn-search-holder').prop('disabled', true);
        $('.input-text-rounded').keyup(function() {
          if($(this).val().length !=0 ) {
            $('.btn-search-holder').prop('disabled', false);
          } else {
            $( ".input-text-rounded").focus();
              $('.btn-search-holder').prop('disabled', true);
              e.preventDefault();
          }
        });


        $('.cbp-link').click(function(e) {
            e.preventDefault();
            window.open($(this).attr('href'), 'ShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });


        if ($("#success-message").hasClass("sib-form-message-panel--active")) {
          $("#sib-container").addClass('hide-me');
        }


    /* eslint-enable */


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js